import { gql } from '@apollo/client'

export const BULKUPDATE_MUTATION = gql`
  mutation BulkUpdate($input: BulkUpdateData!) {
    bulkUpdate(input: $input) {
      trackingID
    }
  }
`
